module.exports = __webpack_public_path__ + "img/faq-list-bg.e238c6c4.png";